export enum HubRecordTypes {
  Project = 'Project',
  Strategy = 'Strategy',
  WholeSystem = 'Whole System',
  ProgramManagement = 'Program Management',
}
